import { DependencyList, EffectCallback, useEffect, useRef } from "react";

/**
 * A custom hook that runs an effect only when its dependencies change,
 * skipping the initial mount.
 * @param {EffectCallback} callback The effect function to run.
 * @param {DependencyList} dependencies An array of dependencies for the effect.
 */
function useDidUpdateEffect(
  callback: EffectCallback,
  dependencies: DependencyList,
): void {
  const isMounted = useRef<boolean>(false);

  useEffect(() => {
    // On the first render, set isMounted to true and do nothing else.
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    // On subsequent renders, if dependencies change, run the callback.
    return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}

export default useDidUpdateEffect;
